export enum DashboardUserRole {
  User = 'user',
  Admin = 'admin',
  SuperAdmin = 'superadmin',
  Sheikh = 'sheikh',
}
